export const Ui: 'admin' | 'seller' | 'buyer' = 'seller';
export const AppName = 'Bitop';
